var svgCache = {};
export default svgCache;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@tanem/svg-injector/esm/svg-cache.js
// module id = 678
// module chunks = 0